module.exports = __webpack_public_path__ + "img/success@2x.5b9a6740.png";